import { createContext, useContext } from 'react'

import { signUpUrl } from '@ui/lib/urls'

// Set by MarketingLayout; every Get Started beneath it follows.
export const SignUpHrefContext = createContext(signUpUrl())

export const useSignUpHref = () => useContext(SignUpHrefContext)
